var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-participant-global-overview',{staticClass:"minimal-critical-height",attrs:{"participants":_vm.participants,"loading":_vm.loading,"show-customer-column":false},on:{"rowclicked":(e) => _vm.rowClicked(e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }